import React, { memo } from 'react';
import { ActionIcon, Flex, Group, Table, Text } from '@mantine/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { type UniqueIdentifier } from '@dnd-kit/core';
import classes from './SortableFieldsTable.module.css';

export type SharedSortableRowProps = {
  id: UniqueIdentifier;
  index: number;
  renderCells: (index: number) => React.ReactNode;
};

const SharedSortableRow = memo(function SharedSortableRow({
  id,
  index,
  renderCells,
}: SharedSortableRowProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    opacity: isDragging ? 0.6 : 1,
    cursor: 'default',
    height: '50px',
  };

  return (
    <Table.Tr ref={setNodeRef} style={style} className={classes.tableRow}>
      {/* Drag handle cell */}
      <Table.Td
        width={60}
        {...attributes}
        {...listeners}
        className={classes.dragHandle}
        style={{ cursor: 'grab' }}
      >
        <Group gap={4} wrap="nowrap">
          <Flex w={28}>
            <ActionIcon
              variant="subtle"
              aria-label="Drag row"
              color="#868e96"
              bg={'transparent'}
              ml={-10}
              style={{ cursor: 'grab' }}
              disabled
            >
              <RxDragHandleDots2 />
            </ActionIcon>
          </Flex>
          <Text c="dimmed" size="xs">
            {index + 1}
          </Text>
        </Group>
      </Table.Td>

      {/* User cells */}
      {renderCells(index)}
    </Table.Tr>
  );
});

export default SharedSortableRow;
